import React from 'react';

export function CzechRepublic(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V171H0V0Z" fill="white"/>
      <path d="M0 171H513V342H0V171Z" fill="#D7141A"/>
      <path d="M0 0L213 171L0 342Z" fill="#11457E"/>
    </svg>
  );
}
